import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {RegisterComponent} from '../Register/register.component';
import {LoginComponent} from './login.component';


 @NgModule({
  imports: [
    RouterModule.forChild([
        { path: 'register', component: RegisterComponent}

    ])
  ],
  exports: [
    RouterModule
  ]
})
export class LoginRoutingModule { }

